// extracted by mini-css-extract-plugin
export default {"cls1":"FeatureFeedback-cls1___d969ac70b127e5c2240","cls2":"FeatureFeedback-cls2___4050c0e1b5e53d0be5a FeatureFeedback-cls1___d969ac70b127e5c2240"};